import React from "react";
import OperationsShell from "@/components/operations/OperationsShell";
import InstallerTasks from "@/pages/InstallerTasks";

/**
 * DEV-019 UAT Correction 4 · Sales Tasks workspace.
 *
 * Reuses the canonical `<InstallerTasks />` implementation — the same
 * component that powers `/installer/tasks` and `/operations/tasks` —
 * and mounts it inside the shared portal shell so Sales users see
 * their assigned tasks WITHOUT being routed into the Operations
 * workspace `/operations/tasks`.
 *
 * Every role gate inside `InstallerTasks` and the backend
 * `/api/tasks` list already restricts a Sales caller to tasks that
 * are either on a Sales-visible project or personally assigned to
 * their linked engineer id (see `routers/tasks.py::list_tasks`,
 * lines ~448–465). No additional client-side filter is added — the
 * page renders exactly what the backend has authorised.
 */
export default function SalesTasks() {
    return (
        <OperationsShell>
            <InstallerTasks embedded />
        </OperationsShell>
    );
}
